import AddTags from '../../Actions/AddTags';
import Delete from '../../Actions/Delete';
import SendCSV from '../../Actions/SendCSV';
import SendToContaqt from '../../Actions/SendToContaqt';
import Subscribe from '../../Actions/Subscribe';
import UnblockEmail from '../../Actions/UnblockEmail';
import UnsubscribeEmail from '../../Actions/UnsubscribeEmail';
import AssignToWorkingAreaOfficeUser from '../../Actions/AssignToWorkingAreaOfficeUser';
import ReassignOfficeUser from '../../Actions/ReassignOfficeUser';
import type { ContactAction, ActionModalProps } from '../../constants';

export const modalMap: Record<ContactAction, React.FC<ActionModalProps>> = {
  AddTags,
  Delete,
  SendCSV,
  SendToContaqt,
  Subscribe,
  UnsubscribeEmail,
  UnblockEmail,
  AssignToWorkingAreaOfficeUser,
  ReassignOfficeUser,
};
